export { TYPEFORM_APPLY_LINK, AIRTABLE_PARTNER_LINK, default } from './useStartupLinks';